import React from 'react';

const DeleteModal = ({ showModal, setShowModal, action, data, body, title, confirmButton, cancelButton, extraData, cancelAction }) => {
    return (
        <div
            className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-5 max-w-[400px] w-[calc(100%-40px)] rounded-[4px] shadow-2xl shadow-gray-900 z-[100] transition ${showModal === true ? 'visible opacity-100' : 'invisible opacity-0'
                }`}
        >
            <div>
                <svg
                    width='22'
                    height='22'
                    viewBox='0 0 22 22'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <g clipPath='url(#clip0_170_12581)'>
                        <path
                            d='M11 0C4.92545 0 0 4.92545 0 11C0 17.0746 4.92545 22 11 22C17.0746 22 22 17.0746 22 11C22 4.92545 17.0746 0 11 0ZM11 20.1339C5.9567 20.1339 1.86607 16.0433 1.86607 11C1.86607 5.9567 5.9567 1.86607 11 1.86607C16.0433 1.86607 20.1339 5.9567 20.1339 11C20.1339 16.0433 16.0433 20.1339 11 20.1339Z'
                            fill='#FAAD14'
                        />
                        <path
                            d='M9.82104 15.3214C9.82104 15.634 9.94522 15.9338 10.1662 16.1548C10.3873 16.3758 10.687 16.5 10.9996 16.5C11.3122 16.5 11.612 16.3758 11.833 16.1548C12.054 15.9338 12.1782 15.634 12.1782 15.3214C12.1782 15.0089 12.054 14.7091 11.833 14.4881C11.612 14.267 11.3122 14.1429 10.9996 14.1429C10.687 14.1429 10.3873 14.267 10.1662 14.4881C9.94522 14.7091 9.82104 15.0089 9.82104 15.3214ZM10.4103 12.5714H11.5889C11.6969 12.5714 11.7853 12.483 11.7853 12.375V5.69643C11.7853 5.58839 11.6969 5.5 11.5889 5.5H10.4103C10.3023 5.5 10.2139 5.58839 10.2139 5.69643V12.375C10.2139 12.483 10.3023 12.5714 10.4103 12.5714Z'
                            fill='#FAAD14'
                        />
                    </g>
                    <defs>
                        <clipPath id='clip0_170_12581'>
                            <rect width='22' height='22' fill='white' />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div className='text-[#434343] font-[500] mb-2.5 mt-4'>
                {title}
            </div>
            <div className='text-[#141414]'>
                {data.length > 0 && (
                    data.map((item, index) => {
                        return <div key={index}>
                            {item.date + ' ' + item.time + ' '}
                        </div>
                    })
                )}
                {data?.date && (
                    <div>
                        {data.singlejapaneseday + ' '}
                    </div>
                )}
                {body}
            </div>
            {/* red extra text */}
            {extraData && (
                <div className='text-[#FF4D4F] mt-1'>
                    {extraData}
                </div>
            )}
            <div className='grid grid-cols-1 sm:grid-cols-2 items-center gap-3 mt-6 max-w-[300px] mx-auto'>
                <button
                    onClick={() => {
                        action(data)
                    }}
                    className={`
                text-[#2F54EB] border-2 border-[#2F54EB] px-5 py-2 rounded-[4px]`}>
                    {cancelButton}
                </button>
                <button
                    onClick={() => {
                        setShowModal(false)
                        if (cancelAction) {
                            cancelAction()
                        }
                    }}
                    className={`text-[white] bg-[#2F54EB] border-2 border-[#2F54EB] px-5 py-2 rounded-[4px]`}
                >
                    {confirmButton}
                </button>
            </div>
        </div>
    );
}

export default DeleteModal;
